import {authenticationConst} from '../constants';

export function authenticationRedu(state = {}, action) {
  switch (action.type) {
    case authenticationConst.LOGIN_SUCCESS:
      return {
        type: action.type,
        user: action.user
      };

    case authenticationConst.LOGOUT_SUCCESS:
      return {
        type: action.type,
        user: null,
        storeAccessed: null
      };

    case authenticationConst.ACCESS_STORE_SUCCESS:
      return {
        type: action.type,
        storeAccessed: action.storeAccessed
      };

    case authenticationConst.LEAVE_STORE_SUCCESS:
      return {
        type: action.type,
        storeAccessed: null
      };

    case authenticationConst.LOGIN_FAILURE:
    case authenticationConst.LOGOUT_FAILURE:
    case authenticationConst.ACCESS_STORE_FAILURE:
      return {
        type: action.type,
        error: action.error
      }

    case authenticationConst.CLEAR:
      return {}
    default:
      return state
  }
}
